import script from "./DetailStatistic.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailStatistic.vue?vue&type=script&setup=true&lang=js"

import "./DetailStatistic.vue?vue&type=style&index=0&id=3d458c80&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d458c80"]])

export default __exports__